import jwtDecode from "jwt-decode";
import { Tokens } from "../../types/webchatConversation";
import { getCookie } from "../other/cookies";

const getJwtToken = (tokenKey: string) => {
  const cookieToken = getCookie(tokenKey);
  if (cookieToken) return cookieToken;

  const localToken = localStorage.getItem(tokenKey);
  return localToken ? localToken : null;
};

const isUserAuthenticated = () => {
  const user = getJwtToken(Tokens.AUTH_TOKEN);
  if (!user) return false;

  const decoded: { exp: number } = jwtDecode(user);
  const currentTime = Date.now() / 1000;
  return decoded.exp >= currentTime;
};

const checkGuestToken = () => {
  const token = getJwtToken(Tokens.GUEST_TOKEN);
  if (!token) return false;

  const decoded: { exp: number } = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  return decoded.exp >= currentTime;
};

const getLoggedInUser = () => {
  const token = getJwtToken(Tokens.AUTH_TOKEN);
  if (!token) return { jwtAuthToken: null, user: null };
  return { jwtAuthToken: token, user: jwtDecode(token) };
};

export { checkGuestToken, getJwtToken, getLoggedInUser, isUserAuthenticated };
